import React from "react";
import { Button, CircularProgress } from "@mui/material";
import classNames from "classnames";

interface LoadingButtonProps {
  isLoading: boolean;
  onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: "text" | "outlined" | "contained";
  size?: "small" | "medium" | "large";
  className?: string;
  fullWidth?: boolean;
  children: React.ReactNode;
  loadingContent?: React.ReactNode;
  isDisabled?: boolean;
  type?: "button" | "submit" | "reset";
  colorClass?: string;
}

const LoadingButton = ({
  isLoading,
  onClick,
  variant = "contained",
  size = "medium",
  children,
  className = "",
  fullWidth = false,
  loadingContent,
  isDisabled = false,
  type = "button",
  colorClass = "",
}: LoadingButtonProps) => {
  const variantClass = classNames(
    "!normal-case !text-[15px]",
    {
      "!bg-tgpt-secondary-main hover:!bg-tgpt-secondary-dark text-white disabled:!bg-action-disabled-background disabled:!text-action-disabled": variant === "contained" && !colorClass,
      "!text-transform-none !text-tgpt-secondary-main hover:!bg-tgpt-secondary-states-hover gap-x-2 !self-center": variant === "text",
      "button-outlined": variant === "outlined",
    }, colorClass);

  return (
    <Button
      variant={variant}
      size={size}
      className={classNames(variantClass, className)}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={isDisabled}
      type={type}
    >
      {isLoading
        ? (
            loadingContent || (
              <span className="flex items-center">
                <CircularProgress color="inherit" size={25} />
              </span>
            )
          )
        : (
            children
          )}
    </Button>
  );
};

export default LoadingButton;
